import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=723e24a6&scoped=true&"
import script from "./menu-list.vue?vue&type=script&lang=js&"
export * from "./menu-list.vue?vue&type=script&lang=js&"
import style0 from "./menu-list.vue?vue&type=style&index=0&id=723e24a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e24a6",
  null
  
)

component.options.__file = "menu-list.vue"
export default component.exports